var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoalStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-star-8349694") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.011765 0 0 0 0 0.274510 0 0 0 0 0.388235 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates-with-Clause-Code---Jul-2026",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "noun-star-8349694"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8765075,4.76279153 L9.27798231,7.27311398 L9.89840123,10.8170986 L9.89781981,10.8170986 C9.9309634,10.9918761 9.8582815,11.1695331 9.71175367,11.2722053 C9.63209355,11.3281574 9.53673242,11.3581514 9.43905515,11.3587287 C9.36288414,11.3581518 9.28846066,11.3391172 9.22159593,11.303354 L6.00905248,9.62941191 L2.80231429,11.303354 C2.64125545,11.4002598 2.43600217,11.3881468 2.28772979,11.2722053 C2.14120197,11.1695317 2.06851412,10.9918761 2.10166366,10.8170986 L2.72208258,7.27311398 L0.141568571,4.76279153 C0.0130668325,4.64108223 -0.0328721518,4.45650265 0.0241146953,4.28922658 C0.082841633,4.11387317 0.241573908,3.99043914 0.427059516,3.97543627 L4.01173524,3.45860518 L5.61830467,0.234760483 L5.61830467,0.234183552 C5.70552354,0.0894014426 5.8636738,0 6.03405084,0 C6.20442788,0 6.36198868,0.0894073492 6.44921648,0.234183552 L8.05578592,3.45802825 L11.5910425,3.97543524 C11.7672248,3.99966133 11.9143361,4.12137062 11.9695754,4.28922554 C12.0323735,4.45189444 11.9963228,4.63532518 11.8765423,4.76279049 L11.8765075,4.76279153 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalStar);
export default __webpack_public_path__ + "static/media/goal-star.37807e5edaa0ce74041a143830edfa56.svg";
export { ForwardRef as ReactComponent };